import { getCookie } from '@susu/cookie'

type AffiliateData = {
  awc: string
  affiliateMarker: string
}

/**
 * Get affiliate data from cookies
 */
export const getAffiliateDataFromCookie = (): AffiliateData => {
  const awc = getCookie('awc') ?? ''
  const affiliateMarker = getCookie('affiliateMarker') ?? ''

  return { awc, affiliateMarker }
}
